import ViewSettlementLettersPage from 'components/viewSettlementLetters/ViewSettlementLetters.component';
import { getCarriers, resetForm } from 'feature/form/formSlice';
import {
	getSettlementLetters,
	resetDocuments,
} from 'feature/settlementLetters/settlementLettersSlice';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'store/store';

export const ViewSettlementLetters = () => {
	const dispatch = useDispatch<AppDispatch>();
	useEffect(() => {
		dispatch(getCarriers(''));
		dispatch(getSettlementLetters(''));

		return () => {
			dispatch(resetForm());
			dispatch(resetDocuments());
		};
	}, [dispatch]);
	return <ViewSettlementLettersPage />;
};
